import * as React from 'react';

export default function SvgComponent(props) {
  return (
    <svg x={0} y={0} viewBox="0 0 31.2 29.5" xmlSpace="preserve" {...props}>
      <g>
        <path
          class="st05"
          d="M27.5,18.6L27.5,18.6c-1.4-0.8-2.6-1.7-3.7-2.8c0,0,0,0,0-0.1c0,0,0,0,0,0c-0.1-0.7-0.1-1.4,0.1-2.1
		c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2l0,0c0.5-0.6,0.9-1.2,1.2-1.9c0.4-1,0.7-2,0.8-3c0.1-0.4,0.1-0.7,0.1-1.1V2.6
		c0-2.5-1.9-2.5-3.1-2.5h-4.6c-1.2,0-3.1,0-3.1,2.5v3.8c-1.4-1.8-3.5-2.9-5.8-2.9c-4.2,0.1-7.6,3.7-7.5,7.9c0,2.9,1.5,5.6,4.1,7.1
		C6.7,18.8,7,19,7.3,19.3c0.1,0.6,0.2,1.2,0.1,1.7c-0.1,0.1-0.2,0.2-0.3,0.3l-0.7,1.2l-1,0.8c-0.1,0-0.2,0.1-0.3,0.2L5,23.6
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.3-0.7,0.4l-0.2,0.1c-1.7,1-3.3,2-3.3,4.2c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2
		c0,0,0,0,0,0l0,0l0,0c0.4-0.1,0.8-0.4,0.8-0.8c0-1.4,1.1-2.1,2.9-3.2c0.3-0.1,0.6-0.3,0.8-0.5c0.1,0,0.1-0.1,0.2-0.1l4,4.2
		c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0.1h0.2c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2
		l4-4.3c0.4,0.2,0.7,0.5,1.1,0.7c1.7,1,2.8,1.7,2.8,3.1c0,0.4,0.2,0.7,0.6,0.8c0.4,0,0.7-0.2,0.8-0.6c0-0.1,0-0.1,0-0.2
		c0-2.2-1.6-3.1-3.2-4.1l-0.2-0.1c-1.1-0.6-2.1-1.4-3-2.2l-0.2-0.3c0.6-0.9,1.5-1.6,2.5-2c1.3-0.7,2.6-1.7,3.6-2.8
		c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.4,0.1c1.1,0.3,2.2,0.2,3.2-0.2c1.1,1.1,2.3,2,3.7,2.7c1.9,1.1,2.9,1.7,2.9,3.1
		c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.3,0.2,0.5,0.3s0.4,0,0.5-0.1c0.1-0.1,0.2-0.3,0.3-0.5c0-0.1,0-0.1,0-0.2
		C31,20.6,29.3,19.6,27.5,18.6z M22.5,15.8c-0.7,0.2-1.5,0.2-2.2,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0
		c0.1-0.9,0-1.8-0.1-2.7c0-0.2-0.1-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.3-0.2-0.5-0.5-0.6-0.8c-0.6-0.9-1-2-1.2-3.1
		c-0.1-0.5-0.1-0.9-0.1-1.4V4.3c0.7,0.3,1.3,0.8,1.7,1.4C19,5.9,19.2,6,19.5,6c0,0,0,0,0,0c0.2,0,0.4-0.1,0.5-0.3
		c0.8-1.1,2.1-1.8,3.4-1.8c0.6,0,1.2,0.1,1.8,0.4v2.9c0,0.3,0,0.6-0.1,0.9c-0.1,0.9-0.3,1.8-0.7,2.6c-0.2,0.6-0.5,1.1-1,1.6
		l-0.5,0.5c-0.1,0.1-0.2,0.2-0.2,0.4C22.5,14,22.4,14.9,22.5,15.8z M19.4,4.4C18.8,3.8,18,3.3,17.1,3l0-0.4c0-1.1,0.3-1.2,1.8-1.2
		h4.6c1.5,0,1.8,0.1,1.8,1.2V3c-0.6-0.2-1.2-0.3-1.8-0.3C21.9,2.7,20.4,3.3,19.4,4.4z M8.8,19.2C8.8,19.2,8.8,19.2,8.8,19.2
		L8.8,19.2c0.3,0.1,0.6,0,0.7-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.2-0.1-0.3c-0.7-1.1-1-2.4-1-3.6c-0.1-2.8,1.7-5.3,4.3-6.3
		c0.4,0.6,0.8,1.3,1,2c0.3,0.8,0.4,1.7,0.4,2.5c0,0.5-0.1,0.9-0.1,1.4l0,0c-0.2,1.1-0.6,2.1-1.2,3c-0.2,0.3-0.4,0.6-0.7,0.8
		c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c-0.1,0.8-0.2,1.7-0.2,2.6l-1.2,1.1H9.9l-1.1-0.9C8.9,20.8,8.9,20,8.8,19.2z
		 M15.4,14.8c0-0.1,0-0.2,0.1-0.3c0.1-0.5,0.1-1,0.1-1.5c0-1-0.1-2-0.4-2.9c-0.3-1-0.8-2-1.6-2.8C13.5,7,13.2,7,12.9,7
		c-3.4,1-5.8,4.1-5.7,7.7c0,1,0.2,1.9,0.5,2.9c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.1-0.2-0.2l0,0c-2.2-1.2-3.5-3.5-3.5-5.9
		C3.8,7.9,6.5,4.9,10,4.8l0.1,0c2.1,0,4.1,1.2,5.1,3c0.7,1.1,1,2.4,1,3.7C16.3,12.6,16,13.8,15.4,14.8z M12.9,19.3
		C12.9,19.2,12.9,19.2,12.9,19.3c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.3,0.5-0.6,0.8-0.9c2-1.3,3.2-3.3,3.5-5.7c0.2,0.3,0.5,0.6,0.7,0.8
		l0.2,0.2c0.2,0.8,0.2,1.5,0.1,2.3c-1,1.1-2.2,2.1-3.5,2.8c-0.8,0.4-1.5,0.9-2.2,1.5C12.8,19.8,12.8,19.5,12.9,19.3z M7.9,22.9
		l0.2-0.2l0.7,0.6l-0.2,0.6L7.9,22.9z M9.4,25.4l0,1.4L6.7,24c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1l1.2,1.8
		c0.1,0.2,0.4,0.3,0.6,0.3C9.1,25.9,9.3,25.7,9.4,25.4L9.4,25.4z M12.2,22.7l-0.7,1.1l-0.2-0.6l0.8-0.7L12.2,22.7z M10.7,25.4
		L10.7,25.4c0.1,0.2,0.3,0.4,0.6,0.4c0.2,0,0.5-0.1,0.6-0.3l1.2-1.8c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0.1,0,0.1,0.1l-2.7,2.9V25.4z"
        />
        <path
          class="st05"
          d="M24.3,6.9c0-0.4-0.2-0.7-0.6-0.7c0,0,0,0-0.1,0h-5.1c0,0,0,0,0,0c-0.4,0-0.7,0.3-0.7,0.7
		c0,0.7,0.8,1.3,1.7,1.3c0,0,0,0,0.1,0c0.5,0,1-0.2,1.4-0.7h0.2c0.3,0.4,0.8,0.7,1.4,0.7c0,0,0,0,0.1,0C23.6,8.2,24.3,7.6,24.3,6.9z
		"
        />
      </g>
    </svg>
  );
}
